import {
  ListItemButton,
  listItemIconClasses,
  listItemTextClasses,
} from '@mui/material';
import type { ReactNode, MouseEvent } from 'react';

interface Props {
  children: ReactNode;
  expanded: boolean;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onTransitionEnd: () => void;
}

export function GroupItemTrigger({
  children,
  expanded,
  onClick,
  onTransitionEnd,
}: Props) {
  return (
    <ListItemButton
      sx={{
        p: 0.5,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        height: 40,
        width: 40,
        display: 'flex',
        gap: 1.25,
        fontWeight: 500,
        fontSize: '0.875rem',

        [`& .${listItemIconClasses.root}`]: {
          minWidth: 0,
          width: 30,
        },

        [`& .${listItemTextClasses.root}`]: {
          opacity: 0,
          visibility: 'hidden',
        },

        ...(expanded && {
          width: '100%',

          [`& .${listItemTextClasses.root}`]: {
            opacity: 1,
            visibility: 'visible',
            transition: 'opacity 0.1s ease-in-out 0.2s',
          },
        }),
      }}
      onClick={onClick}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </ListItemButton>
  );
}
